/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TourStatusEnum } from './tourStatusEnum';


export interface TourStatusRequest { 
    status: TourStatusEnum;
}
export namespace TourStatusRequest {
}


